import { render, staticRenderFns } from "./BaseBox.vue?vue&type=template&id=630bdfa4&"
import script from "./BaseBox.vue?vue&type=script&lang=ts&"
export * from "./BaseBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports